import { LocationType } from '../types/location';
export function isMigrationAddressComplete(address) {
    return ([address.street, address.number, address.neighborhood, address.city, address.state, address.recipientName].every(value => value.trim().length > 0) &&
        /^\d{5}-?\d{3}$/.test(address.postalCode.trim()) &&
        /^[A-Z]{2}$/.test(address.state.trim()));
}
export function migrationAddressToLocation(address) {
    return {
        locationId: '',
        locationType: LocationType.COMMERCIAL,
        country: 'BR',
        address: address.street,
        addressLine2: address.neighborhood,
        zipCode: address.postalCode,
        city: address.city,
        state: address.state,
        number: address.number,
        complement: address.complement,
    };
}
export function locationToMigrationAddress(location, recipientName) {
    return {
        street: location.address,
        neighborhood: location.addressLine2 ?? '',
        postalCode: location.zipCode,
        city: location.city,
        state: location.state,
        number: location.number,
        complement: location.complement,
        recipientName,
    };
}
